import type { InjectionKey, ComputedRef } from 'vue'

export interface SheetContext {
  isOpen: ComputedRef<boolean>
  backButton: ComputedRef<boolean>
  title: ComputedRef<string | undefined>
  handleBack: () => void
}

export const SHEET_CONTEXT_KEY: InjectionKey<SheetContext> = Symbol('sheetContext')
